export const HOUR = 60;
export const MAX = 600;
export const ZEROMINS = 300;
